module["exports"] = [
  "Italia"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/address/default_country.js
 ** module id = 753
 ** module chunks = 0
 **/